import {Component, EventEmitter, forwardRef, Input, Output, ViewChild} from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor, FormControl,
  FormControlDirective, NG_VALUE_ACCESSOR,
} from "@angular/forms";
import {AbstractComponent} from "../abstract.component";

@Component({
    selector: 'app-checkpoint-input',
    templateUrl: './checkpoint-input.component.html',
    styleUrls: ['./checkpoint-input.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckpointInputComponent),
            multi: true
        }],
    standalone: false
})
export class CheckpointInputComponent extends AbstractComponent implements ControlValueAccessor {
  @Input() formId?: string;
  @Input() label?: string = '';
  @Input() tooltipText?: string = '';
  @Input() placeholder?: string = '';
  @Input() translatedLabel?: string;
  @Input() translatedPlaceholder?: string;
  @Input() cssClass?: string;
  @Input() min?: number | string | null = null;
  @Input() max?: number | string | null = null;
  @Input() hideErrorMessage?: boolean;
  @Input() showCopyIcon: boolean = true;
  @Output() copyIconClick = new EventEmitter<void>();

  errorMessages: string[] = [];

  constructor(private controlContainer: ControlContainer) {
    super();
  }

  @ViewChild(FormControlDirective, {static: true}) formControlDirective?: FormControlDirective;

  @Input() formControlName?: string;

  // get hold of FormControl instance no matter formControl or formControlName is given.
  // If formControlName is given, then this.controlContainer.control is the parent FormGroup (or FormArray) instance.
  get control(): FormControl {
    return <FormControl<any>>this.controlContainer!.control!.get(this.formControlName!);
  }

  registerOnTouched(fn: any): void {
    this.formControlDirective?.valueAccessor?.registerOnTouched(fn);
  }

  registerOnChange(fn: any): void {
    this.formControlDirective?.valueAccessor?.registerOnChange(fn);
  }

  writeValue(obj: any): void {
    this.formControlDirective?.valueAccessor?.writeValue(obj);
  }

  setDisabledState(isDisabled: boolean): void {
    this.formControlDirective?.valueAccessor?.setDisabledState!(isDisabled);
  }

  onCopyIconClick(): void {
    this.copyIconClick.emit();
  }
}
